import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './store/actions';
import { Button, Tab, Tabs, Grid, Divider } from '@material-ui/core';
import ScheduledCourseForm from './ScheduledCourseForm';
import DetailCalendar from '../../components/DetailCalendar';
import ScheduledCourseAgenda from './ScheduledCourseAgenda';
import StudentTable from './StudentTable';
import InstructorTable from './InstructorTable';
import StudentProgress from './StudentProgress'
import TabPanelButtons from '../../components/TabPanelButtons';
import CourseDetailSchedule from '../course/CourseDetailSchedule';
import NotificationTable from './NotificationsTable';
import PageHeader from 'main/components/PageHeader';
import moment from 'moment';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        }
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '80%',
        maxWidth: '80%'
    },
});

class ScheduledCourse extends Component {
    state = {
        current_tab: 0,
        scheduled_course_id: 0,
        view_type: '',
        tabValue: 0,
        instructorSearch: '',
        studentSearch: ''
    }

    constructor(props) {
        super(props);

        const scheduled_course_id = this.props.match.params.scheduled_course_id;
        const view_type = this.props.match.params.view_type;

        this.state = {
            ...this.state,
            scheduled_course_id: scheduled_course_id,
            view_type: view_type,
        }
        this.props.updateScheduledCourseLoaded(false);
        this.props.getScheduledCourseData(scheduled_course_id);
        this.props.getStudentProgress(scheduled_course_id);
        // this.props.getAgenda(scheduled_course_id)
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        })
    }

    handleChangeIndex = index => {
        this.setState({ value: index });
    };

    handleSubmit = () => {
        switch (this.state.view_type) {
            case ("create"):
                {
                    this.props.saveScheduledCourse(this.props.currentScheduledCourse);
                    this.props.history.push('/scheduled_course/list');
                    break;
                }

            case ("edit"):
                {
                    this.props.saveScheduledCourse(
                        this.props.currentScheduledCourse,
                        this.props.allStudents.filter(student => student.enrolled_this_course),
                        this.props.allInstructors.filter(instructor => instructor.enrolled_this_course)
                    )
                    this.props.history.push('/scheduled_course/list');
                    break;
                }

            default:
                { }
        }
    }

    handleInstructorSearchChange = (e) => {
        this.setState({
            instructorSearch: e.target.value
        })
    }

    handleStudentSearchChange = (e) => {
        this.setState({
            studentSearch: e.target.value
        })
    }

    handleBack = () => {
        if (this.props.auth.user.role === 'student') {
            return this.props.history.push('/student/courses')
        }
        return this.props.history.goBack();
    }

    getPageContent = (current_tab, view_type) => {
        const { classes, theme, currentScheduledCourse, currentInstructors, currentStudents, allInstructors, allStudents } = this.props;

        switch (current_tab) {
            case (0):
                {
                    return (
                        <ScheduledCourseForm
                            view_type={view_type}
                        />
                    )
                }
            case (1):
                {
                    return (
                        <InstructorTable
                            allInstructors={this.props.allInstructors}
                            view_type={view_type}
                        />
                    )
                }
            case (2):
                {
                    return (
                        <StudentTable
                            allStudents={this.props.allStudents}
                            currentStudents={this.props.currentStudents}
                            view_type={view_type}
                        />
                    )
                }
            case (3):
                {
                    if (this.props.currentScheduledCourse.Unscheduled === 0) {
                        return (

                            <DetailCalendar
                                object_id={currentScheduledCourse.company_calendar_course_id}
                                events={this.props.events}
                                dayEvents={this.props.dayEvents}
                                getSchedule={this.props.getSchedule}
                                getDayEvents={this.props.getDayEvents}
                            />
                        )
                    }
                    else {
                        return (
                            <CourseDetailSchedule
                                Unscheduled={true}
                                mappedLessons={this.props.events.map(event => {
                                    return {
                                        ...event,
                                        LessonName: event.title,
                                    }
                                })}
                                month={0}
                                toggleMonth={null}
                            />
                        )
                    }


                }
            case (4):
                {
                    return (
                        <ScheduledCourseAgenda company_course_id={this.state.scheduled_course_id} />
                    )

                }
            case (5):
                {
                    return (
                        <NotificationTable 
                            view_type={view_type} 
                            notifications={this.props.notifications} 
                            relationData={ {NotificationReference: 'scheduled_course', NotificationReferenceID: this.state.scheduled_course_id} } 
                        />
                    )

                }
            case (6):
                {
                    return (
                        <StudentProgress 
                            history={this.props.history}
                            company_calendar_course_id={this.state.scheduled_course_id}
                            progress={this.props.studentProgress}
                        />
                    )
                }
        }
    }


    render() {
        const { classes, currentScheduledCourse, isScheduledCourseLoaded } = this.props;
        const { current_tab, view_type } = this.state;

        if (!isScheduledCourseLoaded) {
            return <div>loading</div>
        }

        let page_content = <React.Fragment>Loading...</React.Fragment>;
        if (isScheduledCourseLoaded) {
            page_content = this.getPageContent(current_tab, view_type);
        }

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <PageHeader
                        component_name = {
                            currentScheduledCourse.CourseName 
                            + (
                                !currentScheduledCourse.Unscheduled 
                                ? " (" + moment(currentScheduledCourse.StartDate).format('MM-DD-YYYY') + " - " + moment(currentScheduledCourse.EndDate).format('MM-DD-YYYY') + ")"
                                : " (Self-Paced)"
                            )
                        }
                        component_type = {"Scheduled Course"}
                        view_type      = {view_type}
                    />
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%', }}>
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                                scrollable={true}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Detail"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Instructors"
                                    hidden={this.props.auth.user.role === 'student' || this.props.auth.user.role === 'instructor'}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Students"
                                    hidden={this.props.auth.user.role === 'student'}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Schedule"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Agenda"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Notifications"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Progress"
                                />
                            </Tabs>
                            <TabPanelButtons
                                component_name = {"scheduled_course"}
                                view_type      = {view_type}
                                button_list    = {[
                                    {
                                        display:  "Save",
                                        type:     "update",
                                        onClick:  this.handleSubmit,
                                    },
                                    {
                                        type:    "back",
                                        onClick: this.handleBack,
                                    }
                                ]}
                            />
                        </Grid>
                    </div>

                }
                content={
                    <React.Fragment>
                        <div className="p-24">
                            {page_content}
                        </div>
                        {/* <div className="p-24">
                            {button_content}
                        </div> */}
                    </React.Fragment>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getScheduledCourse: Actions.getScheduledCourse,
        updateScheduledCourseLoaded: Actions.updateScheduledCourseLoaded,
        getScheduledCourseData: Actions.getScheduledCourseData,
        toggleInstructor: Actions.toggleInstructor,
        toggleStudent: Actions.toggleStudent,
        saveScheduledCourse: Actions.saveScheduledCourse,
        getSchedule: Actions.getCompanyCourseSchedule,
        getDayEvents: Actions.getDayEvents,
        getAgenda: Actions.getAgenda,
        getStudentProgress: Actions.getStudentProgress
    }, dispatch);
}

function mapStateToProps({ scheduledCourseApp, auth }) {
    return {
        auth,
        isScheduledCourseLoaded: scheduledCourseApp.scheduledCourses.isScheduledCourseLoaded,
        currentScheduledCourse: scheduledCourseApp.scheduledCourses.currentScheduledCourse,
        currentStudents: scheduledCourseApp.scheduledCourses.currentStudents,
        currentInstructors: scheduledCourseApp.scheduledCourses.currentInstructors,
        allStudents: scheduledCourseApp.scheduledCourses.allStudents,
        allInstructors: scheduledCourseApp.scheduledCourses.allInstructors,
        events: scheduledCourseApp.scheduledCourses.events,
        dayEvents: scheduledCourseApp.scheduledCourses.dayEvents,
        agenda: scheduledCourseApp.scheduledCourses.agenda,
        notifications: scheduledCourseApp.scheduledCourses.notifications,
        studentProgress: scheduledCourseApp.scheduledCourses.studentProgress
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ScheduledCourse)));



// WEBPACK FOOTER //
// src/main/content/scheduled_course/ScheduledCourse.js